import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["select", "check"]
  static values = { url: String }

  async save() {
    const response = await patch(this.urlValue, {
      body: { participante: { cargo_id: this.selectTarget.value } }
    })

    if (response.ok) {
      this.checkTarget.classList.remove("hidden")
      setTimeout(() => this.checkTarget.classList.add("hidden"), 2000)
    }
  }
}
